import BaseState from "Engine/base/states/BaseState";
import EntryPoint from 'Engine/EntryPoint';

export default class WaitUserInteractionState extends BaseState {

    constructor(stateData) {
        super(stateData);
    }

    start() {
        EntryPoint.GameModel.isFreeSpinsInActiveState = true;
        super.start();
    }

    stop() {
        this.complete();
    }

    onEnd() {
        super.onEnd();
    }
}
